import type { ThemeState } from '@atlaskit/tokens';
import { themeStringToObject } from '@atlaskit/tokens';

export const getThemePreference = (): Partial<ThemeState> => {
	const savedThemePreference = window.localStorage.getItem('themeColorMode');

	// legacy saved theme
	if (
		savedThemePreference === 'light' ||
		savedThemePreference === 'dark' ||
		savedThemePreference === 'auto'
	) {
		return { colorMode: savedThemePreference };
	}
	if (savedThemePreference != null) {
		const themeObject = themeStringToObject(savedThemePreference);

		return Object.keys(themeObject).length > 0 ? themeObject : getOsThemePreference();
	}

	return getOsThemePreference();
};

const getOsThemePreference = (): Partial<ThemeState> => {
	const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
	if (darkModeMediaQuery.matches) {
		return { colorMode: 'dark' };
	}
	return { colorMode: 'light' };
};
